import {
  GET_MY_BOOKINGS_SUCCESS,
  SEARCH_USER_SUCCESS,
  SET_TOP_SALONS,
} from '../constants';

const initialState = {
  bookings: [],
  userSearchResult: {
    salons: [],
  },
  topSalonBrands: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_MY_BOOKINGS_SUCCESS:
      return { ...state, bookings: action.data };
    case SEARCH_USER_SUCCESS:
      return { ...state, userSearchResult: action.data };
    case SET_TOP_SALONS:
      return { ...state, topSalonBrands: action.data };
    default:
      return state;
  }
};

export default reducer;
